import React from "react";

import Image from "next/image";

import { PortableText } from "@portabletext/react";
import { customRichTextComponent } from "@/sanity/sanityPortableText";

import { PageManifestoSchema } from "@/sanity/pages/PageManifestoTemplate";

import bg from "@/public/global/squares-bg.svg";
import playlist from "@/public/manifesto/playlist.svg";

export default function Last({ data }: { data: PageManifestoSchema }) {
  return (
    <section className="pt-[10rem] lg:pt-[11rem] pb-[8rem] lg:pb-[15rem] overflow-clip relative">
      {/* background */}
      <Image
        src={bg}
        alt="Background"
        className="absolute w-[150%] lg:w-full max-w-[120rem] left-1/2 -translate-x-1/2 top-0 pointer-events-none opacity-90"
      />
      {/* end background */}
      <div className="w-full max-w-[84rem] mx-auto flex flex-col justify-center px-[3rem] lg:px-0">
        <div className="w-fit flex items-center bg-white mb-[2rem]">
          <div className="w-[4rem] bg-[#D9F9B9] p-2">
            <Image src={playlist} alt="icon" className="!w-full" />
          </div>
          <span className="font-geist text-black text-[2rem] font-[400] leading-[100%] px-[1rem] py-[1rem]">
            {data?.settings?.language === "en" ? "Summary" : "Zusammenfassung"}
          </span>
        </div>

        <div className="w-full max-w-[84rem] mx-auto relative z-[1]">
          {data?.lastTexts1 && (
            <PortableText
              value={data?.lastTexts1 ?? []}
              components={customRichTextComponent({
                block: {
                  h2: ({ children }) => (
                    <h2 className="font-funnel text-black text-[4.5rem] lg:text-[6rem] leading-[100%] font-[500] mb-[2rem]">
                      {children}
                    </h2>
                  ),
                  normal: ({ children }) => (
                    <p className="text-black font-[400] leading-[150%] mb-0 text-[2.25rem]">
                      {children}
                    </p>
                  ),
                },
              })}
            />
          )}
        </div>
      </div>

      {/* lines */}
      <div className="h-[.375rem] min-h-[.375rem] flex flex-col w-[179rem] min-w-[179rem] mx-auto overflow-clip lg:my-[4rem] my-[3rem]">
        <span className="w-full min-w-full h-[.125rem] min-h-[.125rem] bg-[#202223]/20"></span>
        <span className="w-full min-w-full h-[.25rem] min-h-[.25rem] bg-white"></span>
      </div>
      {/* end lines */}

      <div className="w-full max-w-[84rem] mx-auto flex flex-col justify-center px-[3rem] lg:px-0">
        {data?.lastTexts2 && (
          <PortableText
            value={data?.lastTexts2 ?? []}
            components={customRichTextComponent({
              block: {
                normal: ({ children }) => (
                  <p className="text-start text-black/60 font-[400] leading-[150%] mb-[2rem] text-[2.25rem]">
                    {children}
                  </p>
                ),
              },
              marks: {
                strong: ({ children }) => (
                  <span className="text-black">{children}</span>
                ),
              },
            })}
          />
        )}

        <div className="w-full flex flex-col gap-[1.25rem]">
          {data?.lastList &&
            data?.lastList?.map((item, index) => (
              <div key={index} className="w-full flex">
                <div className="bg-[#D9F9B9] w-[4rem] h-[6rem] min-h-[6rem] min-w-[4rem] flex items-center justify-center">
                  <span className="font-geist text-black text-[2rem] font-[400] leading-[100%]">
                    {index + 1}
                  </span>
                </div>
                <div className="w-[calc(100%-4rem)] h-[6rem] min-h-[6rem] bg-white flex items-center px-[1rem] py-[1rem]">
                  <span className="text-black text-[2rem] font-[400] leading-[100%]">
                    {item}
                  </span>
                </div>
              </div>
            ))}
        </div>
      </div>

      {/* lines */}
      <div className="h-[.375rem] min-h-[.375rem] flex flex-col w-[179rem] min-w-[179rem] mx-auto overflow-clip lg:my-[4rem] my-[3rem]">
        <span className="w-full min-w-full h-[.125rem] min-h-[.125rem] bg-[#202223]/20"></span>
        <span className="w-full min-w-full h-[.25rem] min-h-[.25rem] bg-white"></span>
      </div>
      {/* end lines */}

      <div className="w-full max-w-[84rem] mx-auto flex flex-col justify-center px-[3rem] lg:px-0">
        {data?.lastFooterTexts && (
          <PortableText
            value={data?.lastFooterTexts ?? []}
            components={customRichTextComponent({
              block: {
                normal: ({ children }) => (
                  <p className="text-start text-black/60 font-[400] leading-[150%] mb-[2rem] text-[2.25rem]">
                    {children}
                  </p>
                ),
              },
              marks: {
                strong: ({ children }) => (
                  <span className="text-black">{children}</span>
                ),
              },
            })}
          />
        )}
      </div>

      {/*  */}
    </section>
  );
}
